// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_fd929a1","status":"_efc399c","titleWrapper":"_e6b7373","cardSubtitle":"_b42d214"};